<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :width="400"
    @cancel="onClose"
  >
    <div class="qrcode-container">
      <div class="qrcode-image">
        <img v-if="qrcodeUrl" :src="qrcodeUrl" />
      </div>
      <div class="version-tag">{{ version }}</div>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineExpose } from 'vue'

// Modal 显示状态
const visible = ref(false)
// 二维码图片地址
const qrcodeUrl = ref('')
// 版本号
const version = ref('')

// 打开 Modal
function showModal(params) {
  visible.value = true
  qrcodeUrl.value = params.qrcodeUrl || 'https://img1.baidu.com/it/u=92091529,3122971829&fm=253&app=138&f=JPEG?w=800&h=1067'
  version.value = params.version || ''
}

// 关闭 Modal
function onClose() {
  visible.value = false
  qrcodeUrl.value = ''
  version.value = ''
}

// 暴露方法
defineExpose({
  showModal
})
</script>

<style lang="less" scoped>
.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
  .qrcode-image {
    width: 300px;
    height: 300px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .version-tag {
    margin-top: 20px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
  }
}
</style>
